import { type ReactElement } from 'react';
import LockIcon from '@pixum/svg-icon/lib/Custom/Lock';
import AwardIcon from '@pixum/svg-icon/lib/Standard/Award';
import CheckIcon from '@pixum/svg-icon/lib/Standard/CheckCircle';
import DeliveryIcon from '@pixum/svg-icon/lib/Standard/Delivery';
import type { FooterProps } from '../../types';
import Label from '@pixum/label';
import './styles.css';
import { TEXT_VARIANT } from '@pixum/text';

interface UspListItem {
  icon: ReactElement;
  text: string;
}

/**
 * Creates a list of unique selling points (USPs) for the footer.
 *
 * @param constants - The constants object containing the i18n strings.
 * @returns An array of UspListItem objects.
 */
function createUspListItems(constants: Record<string, string>): UspListItem[] {
  return [
    {
      icon: <AwardIcon />,
      text: constants.i18n_test_winner,
    },
    {
      icon: <CheckIcon />,
      text: constants.i18n_top_quality,
    },
    {
      icon: <DeliveryIcon />,
      text: constants.i18n_fast_delivery,
    },
    {
      icon: <LockIcon />,
      text: constants.i18n_safe_payment,
    },
  ];
}

/**
 * Renders a list of unique selling points (USPs) for the footer.
 *
 * @param props - The props object containing the constants object.
 * @returns The JSX element representing the USP list.
 */
export function UspList(props: FooterProps) {
  const uspListItems = createUspListItems(props.constants);

  return (
    <section className="footer__usp-list-section">
      <ul className="footer__usp-list">
        {uspListItems.map((usp, index) => (
          <li key={index} className="footer__usp-list-item">
            <Label icon={usp.icon} key={usp.text} text={usp.text} variant={TEXT_VARIANT.HEADLINE} />
          </li>
        ))}
      </ul>
    </section>
  );
}
